import CrudCustom from '../../../libs/custom/CrudCustom';

let PengenaanPajakAkunService = new CrudCustom('/pengenaan-pajak-akuns');
export default PengenaanPajakAkunService;
